"use client"

import { Citrus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CitrusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CitrusIcon = component(Icon)({ as: Citrus })
